import { render, staticRenderFns } from "./ViewCv.vue?vue&type=template&id=5197da70"
import script from "./ViewCv.vue?vue&type=script&lang=js"
export * from "./ViewCv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports